/**
 * A list of all product basenames (verticals).
 *
 * @type {{
 * PRO: string,
 * SCHOOLS: string,
 * CAMPS: string,
 * RESORTS: string,
 * GREEK: string,
 * SPORTS: string,
 * CHURCH: string,
 * SHUTTERBUG: string,
 * }}
 */

const BASENAME = {
  PRO: 'pro',
  SCHOOLS: 'schools',
  CAMPS: 'camps',
  RESORTS: 'resorts',
  GREEK: 'greek',
  SPORTS: 'sports',
  CHURCH: 'church',
  SHUTTERBUG: 'shutterbug',
  EVENTS: 'events',
};

const VIDEO_TUTORIAL_URLS = {
  [BASENAME.PRO]:
    'https://loom.com/share/folder/98b57f29644b4227b780223041b8a303',
  [BASENAME.CAMPS]:
    'https://loom.com/share/folder/28de491b3fbd4e56a45ed64cffcf26ea',
  [BASENAME.SCHOOLS]:
    'https://loom.com/share/folder/1c88d5be6ea3434d8cb493a6fbada67a',
};

export { BASENAME, VIDEO_TUTORIAL_URLS };
